export default __webpack_public_path__ + "static/media/Politicas-De-Privacidad-Edify-2021.f3c73305.pdf";